import { render, staticRenderFns } from "./TranCodeGroupEditor.vue?vue&type=template&id=1991db78&scoped=true"
import script from "./TranCodeGroupEditor.vue?vue&type=script&lang=js"
export * from "./TranCodeGroupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991db78",
  null
  
)

export default component.exports